import { Quote, Building2, Star } from 'lucide-react';

const testimonials = [
  {
    quote: "PositionIQ transformed how we manage position limits. What used to take hours of spreadsheet work now happens automatically.",
    author: "Sarah Chen",
    title: "Chief Compliance Officer",
    company: "Meridian Trading Co.",
  },
  {
    quote: "The real-time alerts have saved us from potential breaches multiple times. It's an essential tool for any serious trading operation.",
    author: "Michael Torres",
    title: "Head of Operations",
    company: "Pacific Commodities Group",
  },
  {
    quote: "Finally, a compliance tool built by people who understand commodity trading. The multi-account aggregation alone is worth it.",
    author: "Jennifer Walsh",
    title: "Compliance Manager",
    company: "Atlantic Futures LLC",
  },
];

const companyLogos = [
  'Meridian Trading',
  'Pacific Commodities',
  'Atlantic Futures',
  'Heartland Grain Co.',
  'Coastal Energy Partners',
  'Summit Metals Trading',
];

export function SocialProofSection() {
  return (
    <section id="testimonials" className="relative py-20 md:py-28 bg-slate-50">
      <div className="container relative">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-slate-100 border border-slate-200 px-4 py-1.5 text-sm mb-6">
            <Star className="h-4 w-4 text-purple-600 fill-purple-600" />
            <span className="text-slate-700 font-medium">Testimonials</span>
          </div>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-slate-900">
            Trusted by{' '}
            <span className="text-purple-600">
              Compliance Professionals
            </span>
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            See what industry leaders say about PositionIQ.
          </p>
        </div>

        {/* Company Logos */}
        <div className="mb-16">
          <p className="text-center text-sm text-slate-500 mb-6">
            Trusted by teams at
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {companyLogos.map((company) => (
              <div
                key={company}
                className="group flex items-center gap-2 text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
              >
                <Building2 className="h-5 w-5" />
                <span className="font-medium text-sm">{company}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative rounded-2xl bg-white border border-slate-200 p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Quote Mark */}
              <div className="absolute top-6 right-6 w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center">
                <Quote className="h-6 w-6 text-purple-600" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-purple-400 fill-purple-400" />
                ))}
              </div>

              <div className="relative">
                <p className="text-slate-600 mb-6 italic leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-full bg-purple-600 flex items-center justify-center">
                    <span className="text-sm font-semibold text-white">
                      {testimonial.author.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-slate-900">{testimonial.author}</p>
                    <p className="text-xs text-slate-500">
                      {testimonial.title}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Placeholder note */}
        <p className="mt-8 text-center text-xs text-slate-400">
          * Testimonials shown are placeholders for demonstration purposes
        </p>
      </div>
    </section>
  );
}
